import React, { useState } from 'react'
import getImageUrl from '../functions/getImageUrl'

const AdvertisementImage = ({imgKey, imgURL, imgTag}) => {
    const [fallbackInUse, setFallback] = useState(false)
    const {finalImageURl, imageUrl } = getImageUrl(imgURL, imgKey === "mobile", false, false, true)

    return (
        imgTag ? 
        (
            <img 
                className={'custom-placement-image custom-placement-image-' + imgKey}
                src={finalImageURl}
                onError={({ currentTarget }) => {
                    if(fallbackInUse) {
                        currentTarget.onerror = null; 
                        currentTarget.src = '';
                    } else {
                        setFallback(true)
                        currentTarget.onerror = null; 
                        currentTarget.src = imageUrl;
                    }
                }}
            />
        ) : (
            <div 
                className={'custom-placement-image custom-placement-image-' + imgKey} 
                style={{backgroundImage: `url(${imgURL})`}}
            />
        )
    )
}

export default AdvertisementImage